import React, { useState } from "react";
import ATitle from "../components/ATitle";
import Form from "./Form";
import RoundProgress from "../components/RoundProgress";
import { blockSelect, devDays, interval } from "../placeholder";
import classNames from "classnames";

export default function ({ className, info, submitName }) {
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    sum: "",
    budget: blockSelect[0],
    devdays: devDays[0],
    interval: interval[0],
    walletaddress: "",
    developers: "",
    tghandle: "",
  });

  const changeHandler = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div
      className={classNames("submission-form", { [className]: !!className })}
    >
      <ATitle text="Product Submission Form" />
      <Form className="form_mt49">
        <div className="timing">
          <h3 className="timing__title">Time Remaing:</h3>
          <div className="timing__svg">
            <RoundProgress current="2" max="5" subtext="Days" />
            <RoundProgress current="12" max="24" subtext="Hours" />
            <RoundProgress current="30" max="60" subtext="Min" />
          </div>
        </div>
        <div className="submission-form__wrapper custom-scrollbar">
          <Form.Input
            title="Product ID:"
            info={
              info !== false &&
              "An Auto-Generated ID associated with each product submission."
            }
            placeholder="Auto-Generated ID"
            className="form-mod__id"
            name="id"
            type="text"
            value={formData.id}
            setValue={changeHandler}
            required
          />
          <Form.Input
            title="Product Unique Name:"
            info={info !== false && "The name that the product will go by."}
            placeholder="Name (text)"
            className="form-mod__name"
            name="name"
            type="text"
            value={formData.name}
            setValue={changeHandler}
            required
          />
          <Form.Input
            title="Product Summary:"
            info={
              info !== false &&
              "This summary is a simple or complex description of a product. It’s preferable to submit the summary in a way so anyone could understand it, but not required. Can be a link, doc, text."
            }
            placeholder="Insert text / Upload Doc"
            className="form-mod__sum"
            name="sum"
            type="text"
            value={formData.sum}
            setValue={changeHandler}
            required
          />
          <Form.Select
            title="Budget:"
            info={
              info !== false &&
              "The amount of ASKO required to create a product. The amount entered must include all payment, as 100% of a product’s profit and ownership will go to the ASKO DAO."
            }
            value={formData.budget}
            setValue={changeHandler}
            items={blockSelect}
            name="budget"
            required
          />
          <Form.Select
            title="Dev Days:"
            info={
              info !== false &&
              "The number of days from development start date to finished product date."
            }
            value={formData.devdays}
            setValue={changeHandler}
            items={devDays}
            name="devdays"
            required
          />
          <Form.Select
            title="Interval:"
            info={
              info !== false &&
              "The interval is a divider over the dev days, that’s used to determine when the budget will be distributed. I.e., if the interval’s 3, and dev days equal 10, then one third of the budget is released when the proposal passes, one third at day 5, one third at day 10. In the case interval is 1, the entire budget will be released initially. In the case the interval is 2, the funds will be released initially and when a finished product is delivered."
            }
            value={formData.interval}
            setValue={changeHandler}
            items={interval}
            name="interval"
            required
          />
          <Form.Input
            title="Submitter Polygon Wallet Address:"
            info={
              info !== false &&
              "The wallet address where the budget will be received over the interval."
            }
            placeholder="0x"
            className="form-mod__aa"
            name="walletaddress"
            type="text"
            value={formData.walletaddress}
            setValue={changeHandler}
            required
          />
          <Form.TextArea
            title="Developer(s):"
            info={
              info !== false &&
              "The developers of the product. Their name(s), linkedin(s), github(s), anything relevant."
            }
            placeholder="xProposed Developer, Default to Asko in-House"
            className="form-mod__aa"
            name="developers"
            value={formData.developers}
            setValue={changeHandler}
            required
          />
          <Form.Input
            title="TG Handle (Optional):"
            info={
              info !== false &&
              "The submitters telegram name and handle ex: @askopiggy"
            }
            placeholder="TG Handle"
            className="form-mod__tg"
            name="tdhandle"
            type="tghandle"
            value={formData.tghandle}
            setValue={changeHandler}
            required
          />
        </div>
        <Form.Submit onClick={(e) => e.preventDefault()}>
          {(submitName && submitName) || "Submit"}
        </Form.Submit>
      </Form>
    </div>
  );
}
